import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { onChangeServiceCentersFilter2 } from '../../../ac/onChangeMapFilters';
import { ServiceCentersFilterValues } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const ServiceCentresComponent = ({
    mapFilters,
    onChangeServiceCentersFilter2,
}) => (
    <div>
        <div className={styles.checkboxIconGrid}>
            {
                ServiceCentersFilterValues.map(({ value, fill, label }) => {
                    const isHighlighted = [ 'ACTIVE', 'PROSPECTIVE' ].includes(value);
                    const circleWidth = isHighlighted ? '1.8vw' : '3.5vw';
                    const circleHeight = isHighlighted ? '2vw' : '1.7vw';

                    // Default label style
                    let labelStyle = isHighlighted
                        ? { fontWeight: 'bold' }
                        : { paddingLeft: '15px' }; // Add left padding for non-highlighted labels

                    // Add padding above for PROSPECTIVE value
                    if ([ 'ACTIVE', 'PROSPECTIVE' ].includes(value)) {
                        labelStyle = { ...labelStyle, paddingTop: '10px', paddingBottom: '10px' }; // Add top padding
                    }

                    return (
                        <Fragment key={value}>
                            <CircleLegend
                                fill={fill}
                                width={circleWidth}
                                height={circleHeight}
                                opacity='0.8'
                            />
                            <label
                                htmlFor={label.id}
                                style={labelStyle}
                            >
                                {i18n._(label)}
                            </label>
                            <div>
                                <label className={styles.switch}>
                                    <input
                                        type='checkbox'
                                        name='poi'
                                        id={value}
                                        checked={mapFilters.ServiceCentersStatuses.includes(value)}
                                        value={value}
                                        onChange={onChangeServiceCentersFilter2}
                                    />
                                    <span className={classnames(styles.sliderRound, styles.slider)} />
                                </label>
                            </div>
                        </Fragment>
                    );
                })
            }
        </div>
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeServiceCentersFilter2 })(ServiceCentresComponent);
export const SeviceCentersFilter = withDisplayedLayersCheck(ConnectedComponent, t`Изохроны доступности сервисных центров`);
